import React from "react";

function ProgInsuranceCCTable({ data }) {
  return (
    <>
      <div>
        <div
          className={`min-w-full ${
            data ? "w-max" : "flex-1"
          }  flex justify-center py-2`}
        >
          <table className="min-w-full bg-white border border-gray-200 text-sm">
            <thead className="bg-brand-primaryColor text-white">
              <tr>
                <th className="px-4 border">Diagnosed Date</th>
                <th className="px-4 border">Chronic Code</th>
                <th className="px-4 border">Description</th>
              </tr>
            </thead>
            <tbody className="text-center">
              {data?.map((item, idx) => (
                <React.Fragment key={idx}>
                  <tr className="text-center">
                    <td className="px-4 border">
                      {item.givenDate
                        ? new Date(item.givenDate).toLocaleDateString()
                        : ""}
                    </td>
                    <td className="px-4 border">{item.chronicCode}</td>
                    <td className="px-4 border">{item.chronicDescription}</td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default ProgInsuranceCCTable;
